module.exports = __webpack_public_path__ + "static/media/arco-icon.00248f37.svg";